import { motion } from "framer-motion";
import { PRODUCTS } from "../../data/content";
import { ArrowUpRight } from "lucide-react";

export const Products = () => {
  return (
    <section
      id="products"
      data-testid="products-section"
      className="relative bg-background py-24 md:py-32 border-t border-border scroll-mt-16"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 md:mb-20 gap-6">
          <div>
            <p className="font-mono-ibm text-xs tracking-widest uppercase text-primary mb-4">
              / Product System
            </p>
            <h2 className="font-display uppercase leading-[0.88] tracking-tight text-5xl md:text-7xl lg:text-8xl">
              The Material
              <br />
              Arsenal
            </h2>
          </div>
          <p className="max-w-sm font-mono-ibm text-xs tracking-wide text-muted-foreground leading-relaxed">
            SIX ENGINEERED PACKAGING SYSTEMS — FROM STRUCTURAL TIMBER TO
            ESD-SAFE FOAM. EACH SPEC'D FOR EXPORT SURVIVAL.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 auto-rows-[300px] md:auto-rows-[280px] gap-px bg-border border border-border">
          {PRODUCTS.map((p, i) => (
            <motion.article
              key={p.id}
              data-testid={`product-${p.id}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease: [0.76, 0, 0.24, 1] }}
              className={`group relative bg-background overflow-hidden ${p.span}`}
            >
              <div className="absolute inset-0 overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover img-industrial"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-background/10 group-hover:from-background/90 transition-colors duration-500" />
              </div>

              <div className="relative z-10 h-full p-6 md:p-8 flex flex-col justify-between">
                <div className="flex items-start justify-between">
                  <span className="font-mono-ibm text-xs tracking-widest text-primary">
                    [{p.index}]
                  </span>
                  <ArrowUpRight
                    size={20}
                    className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 group-hover:-translate-y-1 transition-all"
                  />
                </div>

                <div>
                  <p className="font-mono-ibm text-[10px] md:text-xs tracking-widest text-muted-foreground mb-2">
                    {p.spec}
                  </p>
                  <h3 className="font-display uppercase leading-none tracking-tight text-2xl md:text-3xl mb-3">
                    {p.title}
                  </h3>
                  <p className="max-w-md text-sm text-muted-foreground leading-relaxed max-h-0 opacity-0 group-hover:max-h-40 group-hover:opacity-100 transition-all duration-500 overflow-hidden">
                    {p.desc}
                  </p>
                </div>
              </div>
              <span className="absolute inset-0 border-2 border-primary opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
